"use client";

import { fetchDesigns } from "@/lib/actions/designs/fetchDesigns";
import Image from "next/image";
import { useCallback, useEffect, useMemo, useState } from "react";
import DesignFilter from "./DesignFilter";
import PageHeader from "@/components/PageHeader";
import SafeArea from "@/components/SafeArea";

const Designs = () => {
  const [designs, setDesigns] = useState<DesignItem[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [refreshing, setRefreshing] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  // Fetch data
  const fetchData = useCallback(async () => {
    setLoading(true);
    const data = await fetchDesigns();
    if (data) {
      setDesigns(data); // Update Zustand store with fresh data
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    // Check if designs are already cached in Zustand/MMKV
    if (designs.length > 0) {
      setLoading(false); // Use cached data to populate the UI
    } else {
      fetchData(); // Fetch fresh data if no cache exists
    }
  }, [designs, fetchData]);

  const filteredMaterials = useMemo(() => {
    return designs.filter(
      (material) =>
        material.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
        (selectedCategory === "All" || material.category === selectedCategory)
    );
  }, [designs, searchTerm, selectedCategory]);

  return (
    <SafeArea>
      <PageHeader title="House Designs" />
      <DesignFilter
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
      />
      <div className="flex gap-8 p-2 flex-wrap justify-center">
        {filteredMaterials.map((design: DesignItem, index) => (
          <aside key={index} className="h-[10rem] w-[10rem] rounded-lg">
            <Image
              src={design.image[0]}
              alt={design.name}
              width={200}
              height={200}
              className="object-cover rounded-lg h-[10rem] w-[10rem]"
            />
          </aside>
        ))}
      </div>
    </SafeArea>
  );
};

export default Designs;
